import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@/utils';

function useCognitoError() {
  const error = localStorage.getItem('cognito-error');
  const navigate = useNavigate();
  useEffect(() => {
    if (error) {
      localStorage.removeItem('cognito-error');
      navigate(AppRoutes.ACCESS_DENIED);
    }
  }, [error, navigate]);
}

export default useCognitoError;
